import React from "react"
import { graphql } from "gatsby"

import CmsPage from "@utils/cmsPage"
import { getPrototypePageSlice } from "@utils/prototypeSlices"

const prototypeSlice = getPrototypePageSlice("try")

const TryPage = ({ data }) => {
  const page = data.allDatoCmsMcV2PageMarketing.nodes[0] || {}
  const sectionCollection = page.sectionCollection || {}

  return (
    <CmsPage
      slug={page.slug || "try"}
      seo={page.seo}
      hideHero
      eyebrow={page.eyebrow}
      heading={page.heading}
      summary={page.summary}
      body={page.body}
      heroMediaType={page.heroMediaType}
      heroImageUrl={page.heroImageUrl}
      heroImageAlt={page.heroImageAlt}
      heroVideoUrl={page.heroVideoUrl}
      heroVideoPosterUrl={page.heroVideoPosterUrl}
      contentSections={sectionCollection.contentSections || []}
      contentHtml={page.contentHtml}
      fallbackContentHtml={prototypeSlice.contentHtml}
      extraStyles={prototypeSlice.extraStyles}
      extraHeadLinks={prototypeSlice.extraHeadLinks}
      emptyMessage="Create or seed the try record in mc_v2_page_marketing."
    />
  )
}

export default TryPage

export const query = graphql`
  query TryCmsPageQuery {
    allDatoCmsMcV2PageMarketing(filter: { slug: { eq: "try" } }, limit: 1) {
      nodes {
        seo {
          ...CmsSeoFields
        }
        slug
        eyebrow
        heading
        summary
        body
        heroMediaType
        heroImageUrl
        heroImageAlt
        heroVideoUrl
        heroVideoPosterUrl
        contentHtml
        sectionCollection {
          contentSections {
            ...CmsHtmlSectionFields
          }
        }
      }
    }
  }
`
